module.exports = __webpack_public_path__ + "img/image_second_right.f5d44430.png";